import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { CompanyOrderStatus } from '../schemas/company-order-status.schema';
import { companyOrderSchema } from '../schemas/company-order.schema';

/**
 * Used by a Trimble Maps partner to get all company orders
 * @param status Company Order Status to filter results (optional)
 * @returns Array of all company orders
 */
export function getCompanyOrders(this: unknown, status?: CompanyOrderStatus) {
  const params =
    typeof status === 'undefined'
      ? ''
      : `?${new URLSearchParams([['status', status]]).toString()}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).companyUrl}/orders${params}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(companyOrderSchema)));
}
